<template>
    <div ref="main">
        <slot/>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop, Watch} from 'vue-property-decorator';
    import vMediaQuery from 'v-media-query';

    Vue.use(vMediaQuery);

    @Component
    export default class RatioContainer extends Vue {

        @Prop({type: Number, default: 1})
        ratio;

        @Watch('$mq.resize')
        onResize() {
            const clientWidth = this.$refs.main.clientWidth;
            const newHeight = clientWidth * this.ratio;
            this.$refs.main.style.height = newHeight + 'px';
        }

        mounted() {
            this.onResize();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/RatioContainer.vue